export { default as ScalarSearchInput } from "./ScalarSearchInput.vue.js";
